<template>
  <div>
    <h1>Editar usuário</h1>
    <b-card no-body>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import Form from "../Components/Form.vue";
import { useActions } from "vuex-composition-helpers";
import { useRoute } from "@/composables/useRoute.js";
import { useRouter } from "vue-router/dist/composables.js";
import { useNotify } from "@/composables/useNotify.js";

export default defineComponent({
  components: { Form },
  setup() {
    const $route = useRoute();
    const $router = useRouter();
    const $notifications = useNotify();

    const { ActionNewUser, ActionShow } = useActions("users", [
      "ActionNewUser",
      "ActionShow",
    ]);

    async function loadData(id) {
      try {
        await ActionShow(id);
      } catch (error) {
        $notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });

        $router.push({ name: "users_list" });
      }
    }

    onMounted(async () => {
      ActionNewUser();
      await loadData($route.params.id);
    });

    return {
      loadData,
    };
  },
});
</script>

<style></style>
